import { createChatStore } from "@sill/shared/chat/createChatStore";
import type { ChatDockItem } from "@sill/shared/chat/types";

import type { ClientFrame, ProRenderPayload, ServerFrame } from "../lib/pro-agent-types";

// Pro CRM Copilot chat store (plan 188 W2-M8, task 802) — a thin
// instantiation of the generic `createChatStore` (see
// `frontend/consumer/src/stores/advisor.ts` for the consumer twin this
// mirrors). Pro has no render payloads wired end-to-end yet (see
// `lib/pro-agent-types.ts`'s header comment); this store is still the
// single source of truth for messages/streaming/dock-items so
// `ProChatDock` has one shape to render regardless of what a given
// backend turn does.

export type ProServerFrame = ServerFrame;
export type ProClientFrame = ClientFrame;
export type ProChatDockItem = ChatDockItem<ProRenderPayload>;

export const useProChatStore: ReturnType<
  typeof createChatStore<ProRenderPayload>
> = createChatStore<ProRenderPayload>();
